import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesByCategoryComponent from './sales-by-category.component';

let SalesByCategoryModule = angular
  .module('SalesByCategory', [
    uiRouter
  ])
  .component('salesbycategory', SalesByCategoryComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesByCategory', {
      url: '/sales-by-category',
      data: {
        authRequired: true,
        permsRequired: ['sales-by-category']
      },
      params: {
        dateTo: null,
        dateFrom: null,
        famId: null,
        title: null
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'salesbycategory'
        }
      },
      resolve: {
        itemsObservable: (ContentService, $transition$) => {
          let params = $transition$.params();
          if (params && params.dateTo && params.dateFrom && params.famId){
            return ContentService.findSalesByCategory({
              date_to: params.dateTo.toISOString(),
              date_from: params.dateFrom.toISOString()
            }, params.famId);  
          } else {
            return null;
          }
        },
        dates: ($transition$) => {
          let params = $transition$.params();
          if (params && params.dateTo && params.dateFrom){
            return {
              dateFrom: params.dateFrom,
              dateTo: params.dateTo,
              title: params.title
            };
          } else {
            return null;
          }
        },
        
      }
    });
  })
  .name;

export default SalesByCategoryModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-category/sales-by-category.module.js